import { render, staticRenderFns } from "./tort.vue?vue&type=template&id=b3706294&scoped=true"
import script from "./tort.vue?vue&type=script&lang=js"
export * from "./tort.vue?vue&type=script&lang=js"
import style0 from "./tort.vue?vue&type=style&index=0&id=b3706294&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3706294",
  null
  
)

export default component.exports